export default __webpack_public_path__ + "static/media/imgbox4.4cce27a6.png";